import dayjs from "dayjs";

const PREFIJO_KEY = "sefum_filtro_pruebas";

function clave(usuarioId) {
    return `${PREFIJO_KEY}_${usuarioId || "anon"}`;
}

export function guardarFiltroPruebas(usuarioId, payload) {
    if (!usuarioId) return;
    const fecha = payload?.fecha;
    const guardado = {
        fecha:
            Array.isArray(fecha) && fecha.length >= 2
                ? [
                      dayjs(fecha[0]).toISOString(),
                      dayjs(fecha[1]).toISOString(),
                  ]
                : null,
        tipoPrueba: payload?.tipoPrueba ?? null,
        momento: payload?.momento ?? null,
        atleta: payload?.atleta ?? "",
        institucion: payload?.institucion ?? null,
    };
    try {
        localStorage.setItem(clave(usuarioId), JSON.stringify(guardado));
    } catch (e) {
        console.warn("No se pudo guardar el filtro de pruebas", e);
    }
}

export function leerFiltroPruebas(usuarioId) {
    if (!usuarioId) return null;
    try {
        const raw = localStorage.getItem(clave(usuarioId));
        if (!raw) return null;
        return JSON.parse(raw);
    } catch {
        return null;
    }
}

/** Valores para el Form y payload de `getPruebas`. */
export function restaurarFiltroPruebas(guardado, usuario) {
    if (!guardado) return null;

    let fecha;
    if (Array.isArray(guardado.fecha) && guardado.fecha.length >= 2) {
        const inicio = dayjs(guardado.fecha[0]);
        const fin = dayjs(guardado.fecha[1]);
        if (inicio.isValid() && fin.isValid()) {
            fecha = [inicio, fin];
        }
    }

    const institucion =
        usuario?.rol === "Admin" ? guardado.institucion ?? null : usuario?.institucion ?? null;

    const payload = {
        fecha,
        tipoPrueba: guardado.tipoPrueba ?? undefined,
        momento: guardado.momento ?? undefined,
        atleta: guardado.atleta || undefined,
        institucion,
    };

    return {
        formValues: {
            fecha,
            tipoPrueba: guardado.tipoPrueba ?? undefined,
            momento: guardado.momento ?? undefined,
            atleta: guardado.atleta ?? undefined,
            institucion,
        },
        payload,
    };
}
